class PageCardSignupHero extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initBreadFinancial();
  }

  initBreadFinancial() {
    this.bfSettings = JSON.parse(
      document.getElementById("bread_financial_info").innerHTML
    );
    this.initPlacements();
    this.initPrescreen();
    this.triggerButtons = document
      .querySelectorAll(`[data-bf-accept-trigger]`)
      .forEach((button) => {
        button.addEventListener("click", () => {
          this.initPrescreen(true);
        });
      });

  }

  initPlacements() {
    if (!window?.BreadPayments || !this.bfSettings?.placementId) return;
    BreadPayments.setup({
      env: this.bfSettings?.env ?? "STAGE",
      existingCardHolder: false,
    });

    const landingPlacement = {
      financingType: "card",
      locationType: "landing",
      placementId: this.bfSettings.placementId,
      domID: "bread-payments-landing-placement",
    };

    BreadPayments.registerPlacements([landingPlacement]);
  }

  initPrescreen(manual = false) {
    if (!window?.BreadPayments) return;
    const urlParams = new URLSearchParams(window.location.search);
    const prescreenId = urlParams.get("prescreenId");
    const submitParams = {
      financingType: "card",
      locationType: "landing",
      mockResponse: "success", // 'success', 'noHit', 'makeOffer', 'ackknowledge', 'existingAccount', 'existingOffer', 'newOffer', 'error';
    };
    if (prescreenId) {
      BreadPayments.submitRtps(submitParams);
    } else if (manual) {
      submitParams.customerAcceptedOffer = true;
      BreadPayments.submitRtps(submitParams);
    }
  }
}

customElements.define("page-cardsignup-hero", PageCardSignupHero);
